"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = require("../../../theme/styled");

var NavbarDropdownGroup = styled_1["default"].div(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      children = _ref.children;
  return _ref2 = {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    width: '100%'
  }, _ref2["@media (max-width: " + theme.navbar.collapseAt + ")"] = {
    flex: '0 1 100%'
  }, _ref2;
});
exports["default"] = NavbarDropdownGroup;